import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Alerts = lazy(() => import('es/app/views/site/alerts'));
const EditAlert = lazy(() => import('es/app/views/site/alerts/edit'));
const AlertConfiguration = lazy(() => import('es/app/views/site/alerts/edit/configuration'));
const AlertRecipients = lazy(() => import('es/app/views/site/alerts/edit/recipients'));
const AlertHistory = lazy(() => import('es/app/views/site/alerts/edit/history'));
const AlertNoise = lazy(() => import('es/app/views/site/alerts/edit/noise/Noise'));
const AlertCorrelation = lazy(() => import('es/app/views/site/alerts/edit/correlation'));
const AlertDataViewer = lazy(() => import('es/app/views/site/alerts/edit/data-viewer'));

export function AlertRoutes() {
    return (
        <Route path={siteMap.alerts.search()} element={<Alerts />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={siteMap.alerts.create()} element={<AlertConfiguration />} />
            <Route path={siteMap.alerts.edit().root} element={<EditAlert />}>
                <Route index element={<AlertConfiguration />} />
                <Route path={siteMap.alerts.edit().recipients} element={<AlertRecipients />} />
                <Route path={siteMap.alerts.edit().history} element={<AlertHistory />} />
                <Route path={siteMap.alerts.edit().noise} element={<AlertNoise />} />
                <Route path={siteMap.alerts.edit().correlation} element={<AlertCorrelation />} />
                <Route path={siteMap.alerts.edit().dataViewer} element={<AlertDataViewer />} />
            </Route>
        </Route>
    );
}
